import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => (
	{
		stepThreeWrapper: {
			display       : "flex",
			flexDirection : "column",
			gap           : "1rem"
		},
		earningDescription: {
			color    : theme.other.paletteNew.secondaryDarkGrey,
			fontSize : "1.2rem"
		},
		earningCount: {
			fontWeight : "500",
			fontSize   : "2.4rem"
		},
		rejectedButton: {
			width: "fit-content"
		}
	}
) );